import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteNote } from "../../hooks/useCrm";

export const DeleteNoteModal = ({ show, handleClose, note }) => {
  const [button] = useState(false);
  const idNote = note?.IdNote;
  const { mutateAsync: DeleteNote } = useDeleteNote();
  const handleDeleteNote = async () => {
    await DeleteNote({ IdNote: idNote });
  };
  return (
    <BootstrapModal
      modaltitle="حذف یادداشت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="15px">آیا از حذف این یادداشت مطمئن هستید؟</Typogaphy>
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleDeleteNote();
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
